module.exports = __webpack_public_path__ + "img/Loading-Green_01.bed4d3f2.gif";